import { Box, BoxProps } from "@mui/material";
import type { SystemProps } from "@mui/system";
import type { Theme } from "@mui/material/styles";
import { ReactNode } from "react";
import { mergeSx, splitSystemProps } from "@/utils/system-props";

type PageLayoutProps = {
  header?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
} & BoxProps &
  SystemProps<Theme>;

const PageLayout = ({
  header,
  children,
  footer,
  sx,
  ...others
}: PageLayoutProps) => {
  const { systemSx, rest } = splitSystemProps(others);
  return (
    <Box
      {...rest}
      sx={mergeSx(
        {
          display: "flex",
          flexDirection: "column",
          height: "100%",
          ...systemSx,
        },
        sx
      )}
    >
      {header && <Box>{header}</Box>}

      <Box
        sx={{
          flex: 1,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          mt: header ? 1 : 0,
        }}
      >
        {children}
      </Box>

      {footer && <Box>{footer}</Box>}
    </Box>
  );
};

export default PageLayout;
